export default function (theme) {
    return {
        MuiTabs: {
            root: {
                backgroundColor: theme.palette.background.paper
            }
        },
        MuiTab: {
            wrapper: {
                textTransform: 'none',
                fontSize: 14,
                '@media(max-width:320px)': {
                    fontSize: 13
                }
            },
            textColorPrimary: {
                color: theme.palette.text.primary,
                fontWeight: 600,
                '&$selected': {
                    color: theme.palette.primary.main,
                },
                '&:hover': {
                    backgroundColor: theme.palette.secondary.light,
                }
            }
        }
    };
}